module.exports = __webpack_public_path__ + "img/t-23664-001.19903662.jpg";